import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    switchList: [],
    batchSwitchList: []
  },
  getters: {},
  mutations: {
    setSwitchList(state, payload) {
      state.switchList = payload;
    },
    setBatchSwitchList(state, payload) {
      state.batchSwitchList = payload;
    }
  },
  actions: {
    list({ commit }, coin) {
      api.getSwitchList(coin).then(({ data }) => {
        commit('setSwitchList', data);
      });
    },
    updateSwitchStatus(context, data) {
      return api.updateSwitchStatus(data);
    },
    updateBatchWithdrawSize(context, data) {
      return api.updateBatchWithdrawSize(data);
    },
    updateGasPrice(context, data) {
      return api.updateGasPrice(data);
    },
    updateToColdGasPrice(context, data) {
      return api.updateToColdGasPrice(data);
    },
    batchList({ commit }) {
      api.getBatchSwitchList().then(({ data }) => {
        commit('setBatchSwitchList', data);
      });
    },
    updateBatchSwitchStatus(context, data) {
      return api.updateBatchSwitchStatus(data);
    },
    updateJobBatchSize(context, data) {
      return api.updateJobBatchSize(data);
    }
  }
};

appStore.registerModule('walletSwitchSetting', store);
